var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagSanMarino(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_16367)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 16C32 24.8365 24.8365 32 16 32C7.1635 32 0 24.8365 0 16C0.695625 16 16 13.9131 16 13.9131L32 16Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 7.1635 7.1635 0 16 0C24.8365 0 32 7.1635 32 16",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.351 11.0403L16 17.3913L9.64903 11.0403C8.82771 12.2595 8.3479 13.7269 8.3479 15.3043V17.3913C8.3479 20.7423 10.5132 23.5968 13.518 24.63C13.117 25.416 13.1846 26.397 13.7723 27.1304C14.5528 26.5048 15.3608 25.8573 16.0463 25.308C16.7318 25.8573 17.54 26.5049 18.3204 27.1304C18.915 26.3884 18.9777 25.3928 18.5608 24.6022C21.5246 23.5465 23.6522 20.7129 23.6522 17.3913V15.3044C23.6522 13.7269 23.1723 12.2595 22.351 11.0403Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 22.9566C12.9313 22.9566 10.4348 20.46 10.4348 17.3914V15.3044C10.4348 12.2358 12.9314 9.73926 16 9.73926C19.0686 9.73926 21.5652 12.2358 21.5652 15.3044V17.3914C21.5652 20.46 19.0687 22.9566 16 22.9566Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.478 17.3914V15.3044C19.478 13.3865 17.9176 11.8262 15.9997 11.8262C14.0819 11.8262 12.5215 13.3865 12.5215 15.3044V17.3914L15.9997 18.087L19.478 17.3914Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5215 17.3914C12.5215 19.3093 14.0819 20.8696 15.9997 20.8696C17.9176 20.8696 19.478 19.3092 19.478 17.3914H12.5215Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1739 9.73919C20.1739 8.58663 19.2395 7.65225 18.087 7.65225C17.5523 7.65225 17.065 7.8535 16.6957 8.18407V6.95657H17.3913V5.56525H16.6957V4.86963H15.3044V5.56525H14.6087V6.95657H15.3044V8.18407C14.935 7.8535 14.4477 7.65225 13.913 7.65225C12.7605 7.65225 11.8261 8.58663 11.8261 9.73919C11.8261 10.3571 12.0949 10.9121 12.5217 11.2943V12.5218H19.4782V11.2943C19.9051 10.9121 20.1739 10.3571 20.1739 9.73919Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_16367"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagSanMarino);
export default __webpack_public_path__ + "static/media/flag_san_marino.45bd1df7eccf079fd22adef3a326dc3f.svg";
export { ForwardRef as ReactComponent };